// extracted by mini-css-extract-plugin
module.exports = {"CallbackPage":"CallBackPage_CallbackPage__2ibl_"};